/* eslint-disable ember/no-controller-access-in-routes */
import Route from '@ember/routing/route';

export default class DetailsRoute extends Route {
  setupController(controller, model) {
    super.setupController(controller, model);

    // Set the active tab.
    this.controllerFor('group.topics.topic').set('topicTab', 'detail');
  }
}
